import * as React from "react";
import * as styles from "./QuickJournalCyberpunkRain.css";

const drops = [
    { left: "23%", top: "17%", delay: "-4.1s", duration: "7.7s" },
    { left: "57%", top: "23%", delay: "-2.8s", duration: "8.9s" },
    { left: "81%", top: "13%", delay: "-6.1s", duration: "9.7s" },
    { left: "12%", top: "36%", delay: "-2.3s", duration: "7.1s" },
    { left: "31%", top: "61%", delay: "-5.7s", duration: "9.3s" },
    { left: "47%", top: "28%", delay: "-1.1s", duration: "8.2s" },
    { left: "64%", top: "49%", delay: "-6.4s", duration: "10.1s" },
    { left: "79%", top: "67%", delay: "-3.8s", duration: "8.7s" },
    { left: "90%", top: "39%", delay: "-7.2s", duration: "11.3s" },
];

export function QuickJournalCyberpunkRain({ isPaused }: { isPaused: boolean }) {
    return (
        <div aria-hidden="true" className={styles.rain}>
            {["18%", "49%", "77%"].map((left, index) => (
                <span key={left} className={styles.bokeh} style={{
                    left,
                    top: `${12 + index * 6}%`,
                    animationDelay: `${-index * 3 - 2}s`,
                    animationDuration: `${11 + index * 2}s`,
                    animationPlayState: isPaused ? "paused" : "running",
                }} />
            ))}
            {drops.map(({ left, top, delay, duration }) => (
                <span key={left} className={styles.drop} style={{
                    left, top,
                    animationDelay: delay,
                    animationDuration: duration,
                    animationPlayState: isPaused ? "paused" : "running",
                }} />
            ))}
        </div>
    );
}
